"use client";

import React, { useTransition, useOptimistic } from "react";
import { Button } from "../ui/button";
import { Minus, Plus } from "lucide-react";
import { updateCartQuantity } from "@/services/cart.service";
import { cn } from "@/lib/utils";

const CartCounter = ({
  quantity,
  productId,
  isTable = false,
}: {
  quantity: number;
  productId: number;
  isTable?: boolean;
}) => {
  const [isPending, startTransition] = useTransition();

  const [optimisticQuantity, setOptimisticQuantity] = useOptimistic(quantity);

  const handleChange = (delta: number) => {
    const newQty = Math.max(1, optimisticQuantity + delta);
    setOptimisticQuantity(newQty);

    startTransition(async () => {
      await updateCartQuantity(productId, newQty);
    });
  };

  return (
    <div
      className={cn(
        "flex items-center rounded-full bg-[#f5f5f5]  overflow-hidden",
        {
          "flex-col w-[38px] gap-1": !isTable,
          "justify-between w-full": isTable,
        }
      )}
    >
      <Button
        size="icon"
        variant="ghost"
        // disabled={isPending}
        onClick={() => handleChange(1)}
      >
        <Plus />
      </Button>

      <span className="text-sm">{optimisticQuantity}</span>

      <Button
        size="icon"
        variant="ghost"
        disabled={optimisticQuantity <= 1}
        onClick={() => handleChange(-1)}
      >
        <Minus />
      </Button>
    </div>
  );
};

export default CartCounter;
